module.exports = __webpack_public_path__ + "img/logo.9017f283.png";